import { ActionIcon, Box, Menu } from '@mantine/core';
import { IconArrowLeft, IconLogout } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import mainLogo from '../../logo.png';
import { logoutUser } from '../../store/authSlice';
import AvatarInitials from '../AvatarInitials';
import SuperAdminBadge from './SuperAdminBadge';

// The /superAdmin routes carry no accountId or domainId, so AppNavbar's account
// dropdown, setup-guide button and account-scoped menu items have nothing to
// point at here. This is the same chrome — layout classes, logo, user menu —
// with only the parts that stand on their own without a domain.
const SuperAdminNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  return (
    <header className="app-navbar">
      <div className="navbar-content">
        <img src={mainLogo} alt="Releva" className="navbar-logo" />
        <div className="navbar-divider" />
        <SuperAdminBadge label="Super Admin" show />

        <div className="navbar-spacer" />

        <div className="navbar-right-items">
          <Box display="inline-block">
            <Menu position="bottom-end">
              <Menu.Target>
                <ActionIcon variant="filled" size="lg" radius="xl" aria-label="User menu">
                  <AvatarInitials user={user} />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>
                  <div style={{ textAlign: 'center', paddingTop: 13 }}>
                    <span style={{ fontWeight: 'bold' }}>
                      {user.firstName} {user.lastName}
                    </span>
                    <br />
                    <span>{user.email}</span>
                  </div>
                </Menu.Label>
                <Menu.Divider />
                <Menu.Item leftSection={<IconArrowLeft size={16} />} onClick={() => navigate('/')}>
                  Back to App
                </Menu.Item>
                <Menu.Item leftSection={<IconLogout size={16} />} onClick={() => dispatch(logoutUser())}>
                  Sign Out
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Box>
        </div>
      </div>
    </header>
  );
};

export default SuperAdminNavbar;
